const ITEMS = [
  "3V3 HOOP SUPREMACY",
  "STREET CRED IS EARNED",
  "FIBA 3X3 OFFICIAL RULES",
  "WINNER TAKES THE COURT",
  "B3B BASKETBALL",
  "TALK WITH YOUR GAME",
];

export default function Marquee() {
  const strip = [...ITEMS, ...ITEMS];
  return (
    <div
      data-testid="editorial-marquee"
      className="overflow-hidden border-y border-yellow-500/50 bg-yellow-400 py-3"
    >
      <div className="marquee-track flex w-max items-center">
        {strip.map((item, i) => (
          <span
            key={i}
            className="flex items-center whitespace-nowrap font-heading text-sm font-black uppercase tracking-[0.2em] text-black sm:text-base"
          >
            <span className="px-6">{item}</span>
            <span className="text-purple-800">✦</span>
          </span>
        ))}
      </div>
    </div>
  );
}
